import { qz } from "../client";

const getQZApiVersion = async () => qz.api.getVersion();

export const qzApiVersionQueryOptions = {
  queryFn: getQZApiVersion,
  queryKey: ["qz.api.getVersion"] as const,
};
